module.exports = __webpack_public_path__ + "static/img/title_belle@2x.864a216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_template/title_belle@2x.png
// module id = 1tKu
// module chunks = 0